var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWebsite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 10.247C7.82209 10.6776 8.23302 11.0339 8.70491 11.2917C9.17681 11.5496 9.69863 11.7029 10.235 11.7413C10.7713 11.7797 11.3097 11.7023 11.8135 11.5144C12.3173 11.3264 12.7748 11.0323 13.155 10.652L15.405 8.40204C16.0881 7.69479 16.4661 6.74753 16.4575 5.76429C16.449 4.78105 16.0546 3.84051 15.3593 3.14522C14.664 2.44994 13.7235 2.05556 12.7403 2.04702C11.757 2.03847 10.8098 2.41645 10.1025 3.09954L8.8125 4.38204",
    stroke: "#1B2436",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 8.75383C10.1779 8.32323 9.76698 7.96694 9.29508 7.70913C8.82319 7.45131 8.30137 7.29799 7.76501 7.25958C7.22865 7.22117 6.69031 7.29856 6.18649 7.48649C5.68267 7.67443 5.22516 7.96853 4.845 8.34883L2.595 10.5988C1.9119 11.3061 1.53393 12.2533 1.54247 13.2366C1.55101 14.2198 1.9454 15.1604 2.64068 15.8557C3.33596 16.5509 4.2765 16.9453 5.25974 16.9539C6.24298 16.9624 7.19024 16.5844 7.8975 15.9013L9.18 14.6188",
    stroke: "#1B2436",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebsite);
export default __webpack_public_path__ + "static/media/website.63215a30320cf37c622f5f43dbd2a72a.svg";
export { ForwardRef as ReactComponent };